module.exports = __webpack_public_path__ + "static/media/sem-resultados.99e0f032.svg";